import React from "react";
import { connect } from 'react-redux';
import {
  Form,
  FormElement,
  FormValidator,
  CustomTextControl,
  BaseReactComponent,
  FormSubmitButton,
  SelectControl,
} from "../../utils/form";
import { Row, Col } from "react-bootstrap";
import { ClearButton, CustomModal } from "../common";
import { addCouponApi, getAllPremiumPlanApi, updateCouponApi } from "./Api";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getCustomerNameDropdownApi } from "../customers/Api";
import { isModuleExist, MAX_LIMIT, MODULE_ID_MAP, publishOptions, START_PAGE } from "../../utils/Constant";
import { getAllSsoPartnersApi, getSsoForOptionsApi } from './../sso/Api';
import { getAdminUser, getSafeArray, isPartnerAllowed } from "../../utils/ReusableFunctions";
import { withRouter } from "../../utils/hoc/withRouter";
class CouponForm extends BaseReactComponent {
  constructor(props) {
    super(props);
    const data = props.editData || null;
    const AccesData = isModuleExist(MODULE_ID_MAP.SubscriptionCoupon);

    let partners = this.loadDefaultPartners(AccesData)
    if (data?.partners?.list) {
      partners = data?.partners
    }


    this.state = {
      AccessData: AccesData,
      pageSize: MAX_LIMIT,
      currentPage: START_PAGE,
      isDropdown: true,
      couponCode: data?.couponCode || "",
      isPercentage: data?.uuid ? (data?.isPercentage ? true : '0') : "",
      discountAmount: data?.discountAmount || null,
      discountPercentage: data?.discountPercentage || null,
      startDate: data?.startDate ? new Date(data?.startDate) : "",
      endDate: data?.endDate ? new Date(data?.endDate) : "",
      maxLimit: data?.maxLimit || null,
      userMaxTimeUse: data?.userMaxTimeUse || null,
      isUserSpecific: data?.uuid ? (data?.isUserSpecific ? true : '0') : "",
      customerId: data?.users?.length > 0 && data?.users.map(item => item.uuid) || [],
      customerList: [],
      premiumPlanUuid: data?.premiumPlan?.uuid || null,
      subPremiumPlanUuid: data?.subPremiumPlan?.uuid || null,
      premiumPlanList: [],
      subPremiumPlanList: [],
      ssoOptions: [],
      ssoPartnerUuid: data?.ssoPartner?.uuid || null,
      razorpayId: data?.razorpayId || null,
      partners
    };
  }

  componentDidMount() {

    if (this.props?.editData?.isUserSpecific) {
      this.props.getCustomerNameDropdownApi(this);
    }
    getSsoForOptionsApi(this);
    getAllPremiumPlanApi(this).then((res) => {
      const currentPlan = res?.find((item) => item.uuid === this.state.premiumPlanUuid);
      const subPremiumPlanOptions = currentPlan?.subPremiumPlan.map((item) => ({
        value: item.uuid,
        label: item.name,
      }));
      this.setState({
        subPremiumPlanList: subPremiumPlanOptions || [],
      });
    });
    getAllSsoPartnersApi(this);
  }
  imageUploaser = (e, name) => {

    const imageUrl = URL.createObjectURL(e.target.files[0]);
    if (name === "banner") {
      this.setState({
        bannerPath: e.target.files[0].name,
        bannerfile: e.target.files[0],
        uploadImage2: imageUrl,
      });
    } else {
      this.setState({
        thumbnailPath: e.target.files[0].name,
        thumbnailFile: e.target.files[0],
        uploadImage: imageUrl,
      });
    }
  };

  onValidSubmit = () => {

    let CouponData = {
      data: {
        "couponCode": this.state.couponCode,
        "isPercentage": this.state.isPercentage === '0' ? false : true,
        ...(this.state.isPercentage !== '0'
          ? { "discountPercentage": parseInt(this.state.discountPercentage) }
          : { "discountAmount": parseInt(this.state.discountAmount) }),
        "startDate": this.state.startDate,
        "endDate": this.state.endDate,
        "maxLimit": parseInt(this.state.maxLimit),
        "userMaxTimeUse": parseInt(this.state.userMaxTimeUse),
        "isUserSpecific": this.state.isUserSpecific === '0' ? false : true, //true then pass users id
        ...(this.state.isUserSpecific !== '0' && {
          "users": this.state.customerId?.map((item, i) => ({ uuid: item })),
        }),
        "premiumPlanUuid": this.state?.premiumPlanUuid || null,
        "subPremiumPlanUuid": this.state?.subPremiumPlanUuid || null,
        // "ssoPartnerUuid": this.state?.ssoPartnerUuid || null,
        // "razorpayId": this.state?.razorpayId || null,
        'partners': this.state.partners,
      },
    };
    if(!isPartnerAllowed(this.state.AccessData?.id)){
      delete CouponData.data.partners;
    }

    if (this.props.editData?.uuid) {
      updateCouponApi(
        JSON.stringify(CouponData),
        this.props.this,
        this.props.onHide,
        this.props.editData?.uuid
      );
    } else {
      addCouponApi(
        JSON.stringify(CouponData),
        this.props.this,
        this.props.onHide
      );
    }
  };

  render() {
    console.log(this.state, "this.state");
    const { isPercentage, isUserSpecific } = this.state;
    const { uploadImage, thumbnailFile, bannerfile, uploadImage2 } = this.state;
    return (
      <CustomModal
        show={this.props.show}
        onHide={this.props.onHide}
        title={this.props.editData?.uuid ? 'Edit Coupon' : "Add Coupon"}
        modalClass={"change-password event-ads-modal"}
      >
        <Form onValidSubmit={this.onValidSubmit}>
          <Row>
                        {isPartnerAllowed(this.state.AccessData?.id) && <Col md={4}>

              <FormElement
                valueLink={this.linkState(this, "partners.list")}
                label="Publish To Partner(s)"
                required
                validations={[
                  {
                    validate: FormValidator.isRequired,
                    message: "Publish To cannot be empty",
                  },
                ]}
                control={{
                  type: SelectControl,
                  settings: {
                    options: this.state?.ssoPartnersOptions || [],
                    placeholder: "Select Partner(s)",
                    multiple: true,
                    searchable: true,
                    selectAll: true,
                    onChangeCallback: (onBlur) => {
                    },
                  },
                }}
              />

            </Col>}
            <Col sm={4}>
              <FormElement
                valueLink={this.linkState(this, "couponCode")}
                label="Coupon Code"
                required
                validations={[
                  {
                    validate: FormValidator.isRequired,
                    message: "Coupon code cannot be empty",
                  },
                ]}
                control={{
                  type: CustomTextControl,
                  settings: {
                    placeholder: "Enter coupon code",
                  },
                }}
              />
            </Col>
            <Col sm={4}>
              <FormElement
                valueLink={this.linkState(this, "maxLimit")}
                label="Maximum Limit"
                required
                validations={[
                  {
                    validate: FormValidator.isRequired,
                    message: "Maximum limit cannot be empty",
                  },
                ]}
                control={{
                  type: CustomTextControl,
                  settings: {
                    placeholder: "Enter maximum limit",
                  },
                }}
              />
            </Col>
            <Col sm={4}>
              <FormElement
                valueLink={this.linkState(this, "userMaxTimeUse")}
                label="User Max Time Use"
                required
                validations={[
                  {
                    validate: FormValidator.isRequired,
                    message: "Field cannot be empty",
                  },
                ]}
                control={{
                  type: CustomTextControl,
                  settings: {
                    //   type: "",
                    placeholder: "Enter user max time use",
                  },
                }}
              />
            </Col>
            <Col sm={4}>

              <FormElement
                valueLink={this.linkState(this, "isPercentage")}
                label="Select Type"
                required
                validations={[
                  {
                    validate: FormValidator.isRequired,
                    message: "Field cannot be empty",
                  },
                ]}
                control={{
                  type: SelectControl,
                  settings: {
                    placeholder: "Select value",
                    options: [
                      {
                        value: true,
                        label: "Percentage",
                      },
                      {
                        value: '0',
                        label: "Flat",
                      }
                    ],
                    multiple: false,
                    searchable: true,
                    // disabled:true,
                    onChangeCallback: (onBlur) => {
                      onBlur(this.state.isPercentage);

                    },
                  },
                }}
              />
              {/* } */}
            </Col>

            <Col sm={4}>
              <FormElement
                valueLink={this.linkState(
                  this,
                  isPercentage !== '0' ? "discountPercentage" : "discountAmount"
                )}
                label={isPercentage !== '0' ? "Discount Percentage" : "Discount Amount"}
                required
                validations={[
                  {
                    validate: FormValidator.isRequired,
                    message: "This field cannot be empty",
                  },
                  {
                    validate: isPercentage === 1 ? FormValidator.isWithinInt(0, 100) : FormValidator.isPositiveInt,
                    message: "Please enter a correct value",
                  },
                ]}
                control={{
                  type: CustomTextControl,
                  settings: {
                    //   type: "",
                    // as: "textarea",
                    placeholder: "Enter amount",
                  },
                }}
              />
            </Col>
            <Col md={4}>
              <div className="form-group custom-date-range-picker">
                <label htmlFor="" className="form-label">Start  Of Date <span className=" text-danger">*</span></label>
                <DatePicker
                  selected={this.state.startDate}
                  onChange={(date) => this.setState({ startDate: date, endDate: "" })}
                  // maxDate={new Date()}
                  dateFormat="dd/MM/yyyy"
                  placeholderText="Start date"
                  className="form-control "
                  showYearDropdown
                  dateFormatCalendar="MMMM"
                  yearDropdownItemNumber={50}
                  scrollableYearDropdown
                />
              </div>
            </Col>
            <Col md={4}>
              <div className="form-group custom-date-range-picker">
                <label htmlFor="" className="form-label">End Date <span className=" text-danger">*</span></label>
                <DatePicker
                  selected={this.state.endDate}
                  onChange={(date) => this.setState({ endDate: date })}
                  minDate={this.state.startDate}
                  dateFormat="dd/MM/yyyy"
                  placeholderText="End date"
                  className="form-control "
                  // showMonthDropdown
                  showYearDropdown
                  dateFormatCalendar="MMMM"
                  yearDropdownItemNumber={50}
                  scrollableYearDropdown
                />
              </div>
            </Col>
            <Col sm={4}>
              <FormElement
                valueLink={this.linkState(this, "isUserSpecific")}
                label="Specific User"
                required
                validations={[
                  {
                    validate: FormValidator.isRequired,
                    message: "Field cannot be empty",
                  },
                ]}
                control={{
                  type: SelectControl,
                  settings: {
                    placeholder: "Select value",
                    options: [
                      {
                        value: true,
                        label: "Yes",
                      },
                      {
                        value: '0',
                        label: "No",
                      }
                    ],
                    multiple: false,
                    searchable: false,
                    onChangeCallback: (onBlur) => {
                      onBlur(this.state.isUserSpecific);
                      if (this.state.isUserSpecific !== '0') {

                        this.props.getCustomerNameDropdownApi(this);
                      }
                    },
                  },
                }}
              />
            </Col>
            {isUserSpecific && isUserSpecific !== '0' &&
              <Col sm={4}>
                <FormElement
                  valueLink={this.linkState(this, "customerId")}
                  label="Customer List"
                  required
                  validations={[
                    {
                      validate: FormValidator.isRequired,
                      message: "Field cannot be empty",
                    },
                  ]}
                  control={{
                    type: SelectControl,
                    settings: {
                      options: this.state.customerList,
                      multiple: true,
                      placeholder: "Select value",
                      searchable: true,
                      onChangeCallback: (onBlur) => {
                        onBlur(this.state.customerId);
                      },
                    },
                  }}
                />
              </Col>
            }

            {/* <Col sm={4}>
              <FormElement
                valueLink={this.linkState(this, "ssoPartnerUuid")}
                label="Sso Partner"
                control={{
                  type: SelectControl,
                  settings: {
                    options: this.state.ssoOptions,
                    multiple: false,
                    placeholder: "Select Partner",
                    searchable: true,
                    onChangeCallback: (onBlur) => {
                      onBlur(this.state.ssoPartnerUuid);
                    },
                  },
                }
                }
              />
            </Col> */}
          </Row>
          <Row>
            <Col sm={4}>
              <FormElement
                valueLink={this.linkState(this, "premiumPlanUuid")}
                label="Membership Name"
                control={{
                  type: SelectControl,
                  settings: {
                    options: this.state.premiumPlanList,
                    multiple: false,
                    placeholder: "Select value",
                    searchable: true,
                    canClear: true,
                    onChangeCallback: (onBlur) => {
                      onBlur(this.state.premiumPlanUuid);
                      const plan = this.state.premiumPlanList.find(
                        (item) => item.value === this.state.premiumPlanUuid
                      );
                      const subPremiumPlanOptions = plan?.subPremiumPlan.map((item) => ({
                        value: item.uuid,
                        label: item.name,
                      }));
                      this.setState({ subPremiumPlanList: subPremiumPlanOptions || [] });
                    },
                  },
                }}
              />
            </Col>
            <Col sm={4}>
              <FormElement
                valueLink={this.linkState(this, "subPremiumPlanUuid")}
                label="Plan Name"
                control={{
                  type: SelectControl,
                  settings: {
                    options: this.state.subPremiumPlanList,
                    multiple: false,
                    placeholder: "Select value",
                    searchable: true,
                    onChangeCallback: (onBlur) => {
                      onBlur(this.state.subPremiumPlanUuid);
                    },
                    canClear: true
                  },
                }}
              />
            </Col>
            {/* <Col sm={4}>
              <FormElement
                valueLink={this.linkState(this, "razorpayId")}
                label="Razorpay Id"
                required
                validations={[
                  {
                    validate: FormValidator.isRequired,
                    message: "Razorpay Id cannot be empty",
                  },
                ]}
                control={{
                  type: CustomTextControl,

                  settings: {
                    placeholder: "Enter razorpay id",
                  },
                }}
              />
            </Col> */}
          </Row>
          <div className="submit-wrapper" style={{ justifyContent: "center" }}>
            <FormSubmitButton customClass={"primary-btn"}>
              Save
            </FormSubmitButton>
          </div>
        </Form>
      </CustomModal>
    );
  }
}

const mapStateToProps = state => ({
});
const mapDispatchToProps = {
  getCustomerNameDropdownApi,
}
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CouponForm));
